import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { nanoid } from "nanoid";
import { idValidator } from "../misc/id-validator";
const stringLiteralValue = T.object({
    type: T.literal("literal"),
    value: T.object({
        type: T.literal("string"),
        value: T.string
    })
});
const numberLiteralValue = T.object({
    type: T.literal("literal"),
    value: T.object({
        type: T.literal("number"),
        value: T.number
    })
});
export const PaywallNotificationValidator = T.model("paywall_notification", T.object({
    id: idValidator("paywall_notification"),
    typeName: T.literal("paywall_notification"),
    title: stringLiteralValue,
    subtitle: stringLiteralValue,
    body: stringLiteralValue,
    delay: numberLiteralValue
}));
export const SWPaywallNotificationRecordType = createRecordType("paywall_notification", {
    migrations: defineMigrations({}),
    validator: PaywallNotificationValidator,
    scope: "document"
}).withDefaultProperties(()=>({}));
export function isPaywallNotification(record) {
    if (!record) return false;
    return record.typeName === "paywall_notification";
}
export function isPaywallNotificationId(id) {
    if (!id) return false;
    return id.startsWith("paywall_notification:");
}
/** @public */ export function createPaywallNotificationId(id) {
    return `paywall_notification:${id ?? nanoid()}`;
}
// This is the only notification id we've setup so far
export const trialStartedPaywallNotificationId = createPaywallNotificationId("TRIAL_STARTED");
